<template>
  <v-menu
    class="date-picker"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    offset-overflow
    :top="top"
    :attach="attach"
    min-width="auto">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="formattedDate"
        :label="showLabel ? label : ''"
        :rules="[...rules]"
        prepend-inner-icon="mdi-calendar"
        :disabled="allowModify"
        dense
        outlined
        clearable
        hide-details
        class="date"
        v-bind="attrs"
        v-on="on"
        @click:clear="cleared">
        <template #label v-if="$scopedSlots.label || $slots.label">
          <slot name="label"></slot>
        </template>
      </v-text-field>
    </template>
    <v-date-picker attach @input="emitVal" :value="value" :min="dueMinDate"></v-date-picker>
  </v-menu>
</template>
<script>
  /* eslint-disable */
  import moment from 'dayjs';
  export default {
    props: {
      label: {
        type: String,
        default: () => ' ',
      },
      value: {
        type: String,
        default: () => null,
      },
      useToday: {
        type: Boolean,
        default: () => false,
      },
      showLabel: {
        type: Boolean,
        default: () => true,
      },
      minDate: {
        type: String,
        default: () => null,
      },
      rules: {
        type: Array,
        default: () => [],
      },
      allowModify: {
        type: Boolean,
        default: false,
      },
      top: {
        type: Boolean,
        default: false,
      },
      attach: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        menu: false,
      };
    },
    computed: {
      formattedDate() {
        return this.value ? moment(this.value).format('YYYY-MM-DD') : '';
      },
      dueMinDate() {
        return this.minDate ? moment(this.minDate).format('YYYY-MM-DD') : null;
      },
    },
    mounted() {
      if (this.useToday && (this.value === null || this.value === '')) {
        const today = moment(Date.now()).format('YYYY-MM-DD');
        this.$emit('input', today);
      }
    },
    methods: {
      emitVal(val) {
        this.$emit('input', val);
      },
      cleared() {
        this.$emit('input', null);
      },
    },
  };
</script>
<style scoped>
  .date-picker {
    z-index: 999;
  }
</style>
